import React, { PureComponent } from 'react';
import { FormattedMessage, injectIntl, type IntlShape } from 'react-intl';
import { Notification } from '@setapp/ui-kit';

type Props = {
  intl: IntlShape;
};


class LimitationsNotification extends PureComponent<Props> {

  render() {
    return (
        <Notification type="info">
          <FormattedMessage
            id="manageFamily.newFamilyPlanLimitationsNotification"
            defaultMessage="Starting April 25, 2025, you can no longer add or remove family members from your Setapp Family plan.
Please contact support for any questions. Learn more {contactSupportHereLink}."
            values={{
              contactSupportHereLink: (<a
                href="https://support.setapp.com/hc/en-us/articles/8936786965148-Setapp-Families"
                                       >
                <FormattedMessage id="manageFamily.newFamilyPlanLimitationsNotificationHereLink" defaultMessage="here" />
                                       </a>),
            }}
          />
        </Notification>
    );
  }
}

export default injectIntl(LimitationsNotification);
